module.exports = __webpack_public_path__ + "img/onboarding4.196334f4.png";